/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Overrides_Update_CommentInputs */

const fr_style_overrides_update_comment = /** @type {(inputs: Style_Overrides_Update_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour dynamique :`)
};

const en_style_overrides_update_comment = /** @type {(inputs: Style_Overrides_Update_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic update:`)
};

/**
* | output |
* | --- |
* | "Dynamic update:" |
*
* @param {Style_Overrides_Update_CommentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_update_comment = /** @type {((inputs?: Style_Overrides_Update_CommentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_Update_CommentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_update_comment(inputs)
	return en_style_overrides_update_comment(inputs)
});